import { PayloadAction } from '@reduxjs/toolkit';
import dotPropImmutable from 'dot-prop-immutable';
import {
  DocumentTemplateContentSection,
  DocumentTemplateStore,
} from '../types';

export const documentTemplateSectionSlice = {
  createDocumentTemplateSection: (
    state: DocumentTemplateStore,
    {
      payload: { section, templateId },
    }: PayloadAction<{
      templateId: number;
      section: DocumentTemplateContentSection;
    }>,
  ): DocumentTemplateStore => {
    const result = dotPropImmutable.merge(
      state,
      `${templateId}.template.templateContent.sections`,
      [section.documentSectionId],
    );

    return dotPropImmutable.set(
      result,
      `${templateId}.sections.${section.documentSectionId}`,
      section,
    );
  },
  updateDocumentTemplateContent: (
    state: DocumentTemplateStore,
    {
      payload: { content, sectionId, templateId },
    }: PayloadAction<{
      templateId: number;
      sectionId: number;
      content: string;
    }>,
  ): DocumentTemplateStore => {
    return dotPropImmutable.set(
      state,
      `${templateId}.sections.${sectionId}.content`,
      content,
    );
  },
};
